import React from 'react';
import {toast, ToastContainer} from 'react-toastify'
import store from 'services/redux/store';

const defaultOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const Notification = (type, message, options) => {
    options && Object.entries(options).map(item => {
        defaultOptions[item[0]] = item[1]
    });

    const {locale} = store.getState();
    const translation = locale.translation.Notifications;
    const text = translation[message] ? translation[message] : message;

    switch (type) {
        case "success":
            return toast.success(text, defaultOptions);
        case "info":
            return toast.info(text, defaultOptions);
        case "warning":
            return toast.warning(text, defaultOptions);
        case "error":
            return toast.error(text, defaultOptions);
        case "dark":
            return toast.dark(text, defaultOptions);
        default:
            return toast(text, defaultOptions);
    }
};

const NotificationContainer = () => <ToastContainer rtl style={{textAlign: 'right'}} toastClassName='toastContainer'/>;

export {Notification, NotificationContainer};